import React, {useState} from 'react';
import {BoxProps} from '@material-ui/core/Box';
import {DateTime} from 'luxon';
import LuxonUtils from '@date-io/luxon';
// Note using @material-ui/pickers as recommended in mui docs
// in version 5.x of @material-ui this is in core
import {KeyboardDateInputProps} from '@material-ui/pickers/_shared/KeyboardDateInput';
import {MaterialUiPickersDate} from '@material-ui/pickers/typings/date';
import {
    MuiPickersUtilsProvider, KeyboardDatePicker
} from '@material-ui/pickers';

import {validateEndDate} from '../../../containers/home/utils/end-date-validation';
import {StackProps} from '../../layout/layout.styled';
import {useSnackbar} from '../../snackbars/snackbars';
import {FormControl} from '../form-control/form-control.styles';

export type EndDatePickerFormControlProps = {
    'data-testid'?: string
    labelText: string
    labelProps?: BoxProps
    stackProps?: StackProps
    initialValue: DateTime | null
    startDate: DateTime
    onChange: (date: any) => any
    datePickerProps?: Omit<KeyboardDateInputProps, 'shouldDisableDate' | 'onChange' | 'onAccept'>
}

const DATE_FORMAT = 'dd-MMM-yyyy';

export const EndDatePickerFormControl = ({
    'data-testid': dataTestId = 'SelectFormControl',
    labelText,
    labelProps,
    stackProps,
    datePickerProps,
    startDate,
    onChange,
    initialValue
}: EndDatePickerFormControlProps) => {
    const {enqueueSnackbar} = useSnackbar();
    const [value, setValue] = useState(initialValue);
    const shouldDisableDate = (date: MaterialUiPickersDate) => {
        const result = validateEndDate({
            endDate: date as DateTime,
            startDate
        });
        return result.errors.length > 0;
    };
    const handleChange = (date: MaterialUiPickersDate) => {
        const result = validateEndDate({
            endDate: date as DateTime,
            startDate
        });
        const hasErrors = result.errors.length > 0;
        if (hasErrors) {
            result.errors.forEach(error => {
                enqueueSnackbar(error.message, {variant: 'error'});
            });
            return;
        }
        setValue(date);
        onChange(date);
    };

    return (
        <MuiPickersUtilsProvider utils={LuxonUtils}>
            <FormControl
                data-testid={dataTestId}
                labelText={labelText}
                labelProps={labelProps}
                {...stackProps}
            >
                <KeyboardDatePicker
                    value={value}
                    format={DATE_FORMAT}
                    allowKeyboardControl={true}
                    {...datePickerProps}
                    onChange={handleChange}
                    shouldDisableDate={shouldDisableDate}
                />
            </FormControl>
        </MuiPickersUtilsProvider>
    );
};
